<div>
  <ng-content *ngTemplateOutlet="customSidebar() || defaultSidebar"></ng-content>
</div>

<ng-template #defaultSidebar>
  <div
    id="viewsManager"
    class="menuContainer sidebar"
    role="dialog"
    data-l10n-id="pdfjs-views-manager-sidebar"
    [style.top]="sidebarPositionTop()"
  >
    <div id="viewsManagerHeader">
      <div
        id="additionalSidebarContainer"
        [class.hidden]="hideSidebarToolbar()"
      >
        <pdf-sidebar-toolbar [mobileFriendlyZoomScale]="mobileFriendlyZoomScale()"></pdf-sidebar-toolbar>
      </div>
      <!-- #3141 added by ngx-extended-pdf-viewer
           pdf.js v6 sidebar title row: Add-file button (merge feature) +
           jump-to-current-outline button. Both hidden until pdf.js unhides them
           via enableMerge / outline-view activation. The collapse-when-empty rule
           in views_manager.scss hides the whole row when nothing is visible.
           Upstream's #viewsManagerHeaderLabel (a breadcrumb for the active view)
           is intentionally omitted — ngx's pdf-sidebar-toolbar already shows
           which view is active via the highlighted toolbar button. The dummy
           component still provides an off-screen placeholder so pdf.js's
           data-l10n-id setter doesn't error. -->
      <div id="viewsManagerTitle">
        <button
          id="viewsManagerAddFileButton"
          class="toolbarButton viewsManagerButton"
          type="button"
          tabindex="0"
          data-l10n-id="pdfjs-views-manager-add-file-button"
          hidden="true"
        >
          <span data-l10n-id="pdfjs-views-manager-add-file-button-label">Add file</span>
          <input id="viewsManagerAddFilePicker" type="file" accept="application/pdf,image/*" multiple />
        </button>
        <button
          id="viewsManagerCurrentOutlineButton"
          class="toolbarButton viewsManagerButton"
          type="button"
          tabindex="0"
          data-l10n-id="pdfjs-current-outline-item-button"
          hidden="true"
        >
          <span data-l10n-id="pdfjs-current-outline-item-button-label">Current outline item</span>
        </button>
      </div>
      <!-- #3141 end of addition by ngx-extended-pdf-viewer -->
      <div id="viewsManagerStatus">
        <div id="viewsManagerStatusAction">
          <span id="viewsManagerStatusActionLabelContainer" class="viewsManagerStatusLabel">
            <button
              id="viewsManagerStatusActionDeselectButton"
              class="hidden"
              type="button"
              tabindex="0"
              role="checkbox"
              aria-checked="true"
              aria-labelledby="viewsManagerStatusActionLabel"
            ></button>
            <span
              id="viewsManagerStatusActionLabel"
              class="viewsManagerStatusLabel"
              data-l10n-id="pdfjs-views-manager-pages-status-none-action-label"
            ></span>
          </span>
          <div id="actionSelector">
            <button
              id="viewsManagerStatusActionButton"
              class="viewsManagerButton hasPopupMenu"
              type="button"
              tabindex="0"
              aria-haspopup="menu"
              aria-controls="viewsManagerStatusActionOptions"
              aria-expanded="false"
            >
              <span data-l10n-id="pdfjs-views-manager-pages-status-action-button-label"></span>
            </button>
            <menu id="viewsManagerStatusActionOptions" class="popupMenu">
              <button id="viewsManagerStatusActionCopy" class="noIcon" role="menuitem" type="button" tabindex="-1" disabled>
                <span data-l10n-id="pdfjs-views-manager-pages-status-copy-button-label"></span>
              </button>
              <button id="viewsManagerStatusActionCut" class="noIcon" role="menuitem" type="button" tabindex="-1" disabled>
                <span data-l10n-id="pdfjs-views-manager-pages-status-cut-button-label"></span>
              </button>
              <button id="viewsManagerStatusActionDelete" class="noIcon" role="menuitem" type="button" tabindex="-1" disabled>
                <span data-l10n-id="pdfjs-views-manager-pages-status-delete-button-label"></span>
              </button>
              <button id="viewsManagerStatusActionExport" class="noIcon" role="menuitem" type="button" tabindex="-1" disabled>
                <span data-l10n-id="pdfjs-views-manager-pages-status-export-selected-button-label"></span>
              </button>
            </menu>
          </div>
        </div>
        <div id="viewsManagerStatusUndo" class="hidden">
          <span id="viewsManagerStatusUndoLabel" class="viewsManagerStatusLabel"></span>
          <div>
            <button id="viewsManagerStatusUndoButton" class="viewsManagerButton" type="button" tabindex="0">
              <span data-l10n-id="pdfjs-views-manager-status-undo-button-label"></span>
            </button>
            <button
              id="viewsManagerStatusUndoCloseButton"
              class="toolbarButton viewsManagerButton viewsCloseButton"
              type="button"
              tabindex="0"
              data-l10n-id="pdfjs-views-manager-status-close-button"
            >
              <span data-l10n-id="pdfjs-views-manager-status-close-button-label"></span>
            </button>
          </div>
        </div>
        <div id="viewsManagerStatusWarning" class="hidden">
          <span id="viewsManagerStatusWarningLabel" class="viewsManagerStatusLabel"></span>
          <button
            id="viewsManagerStatusWarningCloseButton"
            class="toolbarButton viewsManagerButton viewsCloseButton"
            type="button"
            tabindex="0"
            data-l10n-id="pdfjs-views-manager-status-close-button"
          >
            <span data-l10n-id="pdfjs-views-manager-status-close-button-label"></span>
          </button>
        </div>
        <div id="viewsManagerStatusWaiting" class="hidden">
          <span id="viewsManagerStatusWaitingLabel" class="viewsManagerStatusLabel"></span>
          <button
            id="viewsManagerStatusWaitingCloseButton"
            class="toolbarButton viewsManagerButton viewsCloseButton"
            type="button"
            tabindex="0"
            data-l10n-id="pdfjs-views-manager-status-close-button"
          >
            <span data-l10n-id="pdfjs-views-manager-status-close-button-label"></span>
          </button>
        </div>
      </div>
    </div>
    <pdf-sidebar-content
      [customThumbnail]="customThumbnail()"
      (thumbnailDrawn)="thumbnailDrawn.emit($event)"
      [hideSidebarToolbar]="hideSidebarToolbar()"
      [mobileFriendlyZoomScale]="mobileFriendlyZoomScale()"
    ></pdf-sidebar-content>
    <div id="viewsManagerResizer" class="sidebarResizer" role="separator" aria-controls="viewsManager" tabindex="0" data-l10n-id="pdfjs-views-manager-sidebar-resizer"></div>
  </div>
</ng-template>
